import { DynamicElementManager } from "../managers/DynamicElementManager";


export class DynamicElementObserver {
  constructor() {
    this.observer = new MutationObserver(this._handleMutations.bind(this));
    this.observeDocument();
    this.initExistingElements();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initExistingElements() {
    document.querySelectorAll('.dinamicElement').forEach((elem) => {
      // Если у элемента ещё нет менеджера, создаём
      if (!elem.dynamicElementManagerInstance) {
        new DynamicElementManager({ elem });
      }
    });
  }

  _handleMutations(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          // Проверяем, является ли добавленный узел контейнером
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Если сам узел — dinamicElement
            if (node.matches && node.matches('.dinamicElement')) {
              if (!node.dynamicElementManagerInstance) {
                new DynamicElementManager({ elem: node });
              }
            }

            // Если внуки внутри узла — dinamicElement
            node.querySelectorAll?.('.dinamicElement').forEach((inner) => {
              if (!inner.dynamicElementManagerInstance) {
                new DynamicElementManager({ elem: inner });
              }
            });
          }
        });
      }
    });
  }
}
